import Component from '../../shared/component';

export default class TopBannerApp extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$topBannerClose = this.$element.find('.topBannerApp-close');
    this.$navbar = $('.navbar.navbar-fixed-top');

    this.openBanner();
    this.bindEvents();
  }

  bindEvents() {
    this.closeBanner = this.closeBanner.bind(this);

    this.$topBannerClose.on('touchstart click', this.closeBanner);
  }

  unbindEvents() {
    this.$topBannerClose.off('touchstart click', this.closeBanner);
  }

  openBanner() {
    this.$element.addClass('topBannerApp--visible');
  }

  closeBanner() {
    this.$element.remove();
  }
}
